import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/** Doble nota con viga (♫) — dos corcheas unidas, estilo icono de audio/música. */
const DoubleEighthNoteIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Plicas */}
    <rect x="8" y="4.8" width="1.6" height="12.6" />
    <rect x="18" y="2.9" width="1.6" height="12.6" />
    {/* Doble viga superior (inclinada) */}
    <polygon points="8,3.9 19.6,2 19.6,4.4 8,6.3" />
    <polygon points="8,6.9 19.6,5 19.6,7.4 8,9.3" />
    {/* Cabezas de nota */}
    <ellipse cx="6.2" cy="17.3" rx="3" ry="2.3" />
    <ellipse cx="16.2" cy="15.4" rx="3" ry="2.3" />
  </SvgIcon>
);

export default DoubleEighthNoteIcon;
